import {
  CartAddWheelPackageModel,
  CartExpressCheckoutModel,
  CartModel,
  CartRowEditModel,
  CartRowOptionEditModel,
  CartRowVehicleEditModel,
  OrderCreatedModel,
  SveaCheckoutResponseModel
} from '@/types/api'
import { baseApi } from './baseApi'

// Leaving out licensePlate keeps the row's plate and vehicle; sending one looks the vehicle up again.
export type CartRowVehicleUpdate = Omit<CartRowVehicleEditModel, 'licensePlate'> & { licensePlate?: string }

const cartApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCart: builder.query<CartModel, string>({
      query: (countryCode: string) => `Cart?countryCode=${countryCode}`,
      providesTags: ['Cart']
    }),
    getSveaCheckout: builder.query<SveaCheckoutResponseModel, number>({
      query: (payload) => `SveaCheckout/${payload}`,
      providesTags: ['Cart'],
      keepUnusedDataFor: 3600,
    }),
    prepareExpressCheckout: builder.mutation<OrderCreatedModel, CartExpressCheckoutModel>({
      query: (payload) => ({
        url: `CartExpressCheckout`,
        method: 'POST',
        body: payload,
      }),
    }),
    deleteCart: builder.mutation<CartModel, void>({
      query: () => ({
        url: `Cart`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cart'],
    }),
    addCartRow: builder.mutation<CartModel, CartRowEditModel>({
      query: (payload) => ({
        url: `CartRow`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
    addWheelPackage: builder.mutation<void, CartAddWheelPackageModel>({
      query: (payload) => ({
        url: `CartWheelPackage`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
    editCartRow: builder.mutation<CartModel, CartRowEditModel>({
      query: (payload) => ({
        url: `CartRow`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
    editCartRowOption: builder.mutation<CartModel, CartRowOptionEditModel>({
      query: (payload) => ({
        url: `CartRowOption`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
    editCartRowVehicle: builder.mutation<void, CartRowVehicleUpdate>({
      query: (payload) => ({
        url: `CartRowVehicle`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Cart'],
    }),
    deleteCartRow: builder.mutation<CartModel, number>({
      query: (payload) => ({
        url: `CartRow/${payload}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Cart'],
    }),
  }),
})

export const {
  useGetCartQuery,
  useAddCartRowMutation,
  useAddWheelPackageMutation,
  useEditCartRowMutation,
  useEditCartRowOptionMutation,
  useEditCartRowVehicleMutation,
  useDeleteCartMutation,
  useDeleteCartRowMutation,
  useGetSveaCheckoutQuery,
  usePrepareExpressCheckoutMutation,
  util: { getRunningQueriesThunk },
} = cartApi

export const { getSveaCheckout } = cartApi.endpoints